module.exports = __webpack_public_path__ + "img/6_no.7132c6a6.svg";